import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const LifePolicyUpdates = Loadable(
  lazy(() =>
    import("./LifePolicyUpdates").then(({ LifePolicyUpdates }) => ({
      default: LifePolicyUpdates,
    }))
  )
);

export const LifePolicyUpdatesRoutes = [
  {
    path: `/life-insurance-policy/:customerId/updates/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <LifePolicyUpdates />
      </AuthorizedRoute>
    ),
  },
]